export default {
  path: 'manage-client',
  component: () => import('@/views/Route'),
  children: [
    {
      path: '',
      name: 'Manage Client',
      component: () => import('@/views/menus/manageClient/Index'),
      meta: {
        permission: true
      }
    }
  ]
}
